export default __webpack_public_path__ + "static/media/xdc-tok.788988cd.png";